document.addEventListener('DOMContentLoaded', function() {
    const mobileMenuToggle = document.getElementById('mobileMenuToggle');
    const navMenu = document.getElementById('navMenu');
    function setMenu(open) {
        navMenu.classList.toggle('active', open);
        mobileMenuToggle.setAttribute('aria-expanded', String(open));
    }
    if (mobileMenuToggle && navMenu) {
        mobileMenuToggle.addEventListener('click', function() {
            setMenu(!navMenu.classList.contains('active'));
        });
        navMenu.querySelectorAll('a').forEach((link)=>{
            link.addEventListener('click', ()=>setMenu(false));
        });
    }
    const contactForm = document.getElementById('contactForm');
    if (!contactForm) return;
    const submitButton = contactForm.querySelector('button[type="submit"]');
    const status = document.getElementById('formStatus');
    const originalButtonText = submitButton.textContent;
    contactForm.addEventListener('submit', async function(e) {
        e.preventDefault();
        submitButton.textContent = "Sending\u2026";
        submitButton.disabled = true;
        status.textContent = '';
        status.className = 'form-status';
        try {
            const response = await fetch(contactForm.action, {
                method: 'POST',
                body: new FormData(contactForm),
                headers: {
                    'Accept': 'application/json'
                }
            });
            if (!response.ok) throw new Error('Form submission failed');
            contactForm.reset();
            status.textContent = 'Message sent. I usually reply within a day.';
            status.classList.add('ok');
        } catch (error) {
            status.textContent = "That didn\u2019t send. Email contact@dephyned.com directly and I\u2019ll pick it up there.";
            status.classList.add('err');
            console.error('Form submission error:', error);
        } finally{
            submitButton.textContent = originalButtonText;
            submitButton.disabled = false;
        }
    });
});

//# sourceMappingURL=company-website.256c31fd.js.map
